export const REQUEST_SPECIALTIES = 'request-specialties';
export const SPECIALTIES_LOADED = 'specialties-loaded';

export function requestSpecialties() {
    return {
        type: REQUEST_SPECIALTIES
    }
}

export function loadedSpecialties(payload) {
    return {
        type: SPECIALTIES_LOADED,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/specialties.action.js